import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddInitialCashComponent } from './add-initial-cash.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { DesignUtilitiesModule } from 'src/app/appModules/design-utilities.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [AddInitialCashComponent],
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
    DesignUtilitiesModule,
    TranslateModule,
  ],
  exports: [AddInitialCashComponent, TranslateModule],
})
export class AddInitialCashModule {}
